import '@babel/polyfill';
import '@codev/helix-bootstrap';
import 'url-search-params-polyfill';
import 'whatwg-fetch';
import window from './globalWrappers/window.js';
import initWebmailForgotPasswordView from './initWebmailForgotPasswordView.jsx';

window.initWebmailForgotPasswordView = initWebmailForgotPasswordView;
